import { ConsoleSqlOutlined } from "@ant-design/icons";
import { Button, Menu, Modal, Row, Col, Image, List, notification } from "antd";
import { useEffect, useState } from "react";
import apiMaestras from "../../../api/Maestras/api-maestras";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import apiDocumentos from "../../../api/Documentos/api-documentos";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";
import { Dropdown, Icon } from "semantic-ui-react";
import EscudoAlcaldiaBlanco from "../../../assets/landing/medellin.png";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Content } from "antd/lib/layout/layout";
import './style.scss'
import getStorageUser from "../../../middlewares/GetStorageUser"
import apiJurados from "../../../api/Jurados/api-jurados";
const { SubMenu } = Menu;



type VerMasProyectosProps = {
    openModal: boolean,
    setOpenModal: Function,
    datos: any
}

export const VerMasProyectos = ({ openModal, setOpenModal, datos }: VerMasProyectosProps) => {

    const [juradosCriterios, setJuradosCriterios] = useState([])
    const [informeEvaluacion, setInformeEvaluacion] = useState('')
    const [user, setUser] = useState<any>({});


    const onCancel = () => {
        setOpenModal(!openModal)
    }

    const openNotification = ({ titulo, descripcion, placement }: any) => {
      notification.info({
        message: titulo,
        description: descripcion,
        placement,
      });
    };

    const evaluar = async (sumatoriaTotal) => {
      let puntajePromedio = sumatoriaTotal
      let estadoNuevo = "Evaluado";
      let id = datos.id_postulacion
      await apiParticipantes.cambiarEstadoPostulacion({ id_postulacion: id, estado: estadoNuevo });
      await apiParticipantes.notaFinalPostulacion({ id_postulacion: id, puntajePromedio: puntajePromedio });

      openNotification({
        titulo: "Finalizado correctamente",
        descripcion: "Se han actualizado el estado de la propuesta y es visible por el participante en: Evaluación de proyectos",
        placement: "bottomRight",
      });
    }

    const porEvaluar = async () => {
      let puntajePromedio = 0
      let estadoNuevo = "Por evaluar";
      let id = datos.id_postulacion
      await apiParticipantes.cambiarEstadoPostulacion({ id_postulacion: id, estado: estadoNuevo });
      await apiParticipantes.notaFinalPostulacion({ id_postulacion: id, puntajePromedio: puntajePromedio });

      openNotification({
        titulo: "Finalizado correctamente",
        descripcion: "Se han actualizado el estado de la propuesta. Por evaluar",
        placement: "bottomRight",
      });
    }

    const obtenerConvoca = async () => {
      let response = await apiConvocatorias.getConvocatoriaById(datos.postulacion.convocatoria_id);
      return response.data;
    }

    const numerosEnPalabras: string[] = [
      'Cero', 'Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco', 'Seis', 'Siete', 'Ocho', 'Nueve',
      'Diez', 'Once', 'Doce', 'Trece', 'Catorce', 'Quince', 'Dieciséis', 'Diecisiete', 'Dieciocho', 'Diecinueve',
      'Veinte', 'Veintiuno', 'Veintidós', 'Veintitrés', 'Veinticuatro', 'Veinticinco', 'Veintiséis', 'Veintisiete', 'Veintiocho', 'Veintinueve',
      'Treinta', 'Treinta y uno', 'Treinta y dos', 'Treinta y tres', 'Treinta y cuatro', 'Treinta y cinco', 'Treinta y seis', 'Treinta y siete', 'Treinta y ocho', 'Treinta y nueve',
      'Cuarenta', 'Cuarenta y uno', 'Cuarenta y dos', 'Cuarenta y tres', 'Cuarenta y cuatro', 'Cuarenta y cinco', 'Cuarenta y seis', 'Cuarenta y siete', 'Cuarenta y ocho', 'Cuarenta y nueve',
      'Cincuenta', 'Cincuenta y uno', 'Cincuenta y dos', 'Cincuenta y tres', 'Cincuenta y cuatro', 'Cincuenta y cinco', 'Cincuenta y seis', 'Cincuenta y siete', 'Cincuenta y ocho', 'Cincuenta y nueve',
      'Sesenta', 'Sesenta y uno', 'Sesenta y dos', 'Sesenta y tres', 'Sesenta y cuatro', 'Sesenta y cinco', 'Sesenta y seis', 'Sesenta y siete', 'Sesenta y ocho', 'Sesenta y nueve',
      'Setenta', 'Setenta y uno', 'Setenta y dos', 'Setenta y tres', 'Setenta y cuatro', 'Setenta y cinco', 'Setenta y seis', 'Setenta y siete', 'Setenta y ocho', 'Setenta y nueve',
      'Ochenta', 'Ochenta y uno', 'Ochenta y dos', 'Ochenta y tres', 'Ochenta y cuatro', 'Ochenta y cinco', 'Ochenta y seis', 'Ochenta y siete', 'Ochenta y ocho', 'Ochenta y nueve',
      'Noventa', 'Noventa y uno', 'Noventa y dos', 'Noventa y tres', 'Noventa y cuatro', 'Noventa y cinco', 'Noventa y seis', 'Noventa y siete', 'Noventa y ocho', 'Noventa y nueve', 'Cien'
    ];

    const obtenerLetras = (num: number) => {
      if (num >= 0 && num <= 100) {
        return numerosEnPalabras[num];
      } else {
        return 'Sin dato';
      }
    }

    const imprimir = () => {
      const modalContent = document.getElementById('modal_custom');
      if (modalContent) {
          html2canvas(modalContent).then(canvas => {
              const radicado = datos.radicado
              const pdf = new jsPDF('p', 'mm', 'a4');
              const pageWidth = 210;
              const pageHeight = 297;
              const margin = 5; // Margen en mm

              const canvasWidth = canvas.width;
              const canvasHeight = canvas.height;

              const imgWidth = pageWidth - 2 * margin;
              const imgHeight = (canvasHeight * imgWidth) / canvasWidth;

              const footerElements = modalContent.querySelectorAll('#footer');
              let positions = [];

              footerElements.forEach(footer => {
                  const rect = footer.getBoundingClientRect();
                  const modalRect = modalContent.getBoundingClientRect();
                  const footerPosition = rect.top - modalRect.top;
                  positions.push(footerPosition);
              });

              let currentHeight = 0;
              let pageIndex = 0;

              for (let i = 0; i <= positions.length; i++) {
                  let pageCanvas = document.createElement('canvas');
                  let pageContext = pageCanvas.getContext('2d');
                  pageCanvas.width = canvasWidth;
                  pageCanvas.height = Math.min(positions[i] - currentHeight || canvasHeight - currentHeight, canvasHeight - currentHeight);

                  pageContext.drawImage(canvas, 0, currentHeight, canvasWidth, pageCanvas.height, 0, 0, canvasWidth, pageCanvas.height);

                  let pageData = pageCanvas.toDataURL('image/png');
                  let pageImgHeight = (pageCanvas.height * imgWidth) / canvasWidth;

                  pdf.addImage(pageData, 'PNG', margin, margin, imgWidth, pageImgHeight);
                  currentHeight += pageCanvas.height;

                  if (currentHeight < canvasHeight && i < positions.length) {
                      pdf.addPage();
                  }
              }

              pdf.save(radicado);
          });
      }
    };

    const eliminarCriterio = async(id) => {
      const {data} = await apiJurados.eliminarCriterio(id)
    };

    const eliminarAsignacion = async(jury_id, postulacion_id) => {
      const {data} = await apiJurados.eliminarAsignacion(jury_id, postulacion_id)
    };

    const firmaPorjurado = async (jurado) => {
      if (jurado && jurado.firma) {
        const firma = await apiDocumentos.consultarArchivo(jurado.firma);
        if (firma && firma.data) {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(firma.data);
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
          });
        }
      }
      return null;
    };

    const obtenerJuradosCriterios = async () => {
      const { data } = await apiParticipantes.obtenerJuradosCriterios(datos.id_postulacion);
      if (data) {
        const juradosCriteriosConFirmas = await Promise.all(
          data.map(async (jurado) => {
            const src = await firmaPorjurado(jurado);
            return { ...jurado, src };
          })
        );
        setJuradosCriterios(juradosCriteriosConFirmas);
      }
      let convocatoria = await apiConvocatorias.getConvocatoriaById(datos.postulacion.convocatoria_id);
      for (const element of convocatoria.data.fechas) {
        if (element.clave === "Informe de evaluación") {
          if (element.valormin) {
            let informe = new Date(element.valormin);
            if (!isNaN(informe.getTime())) { // Verifica que la fecha sea válida
              let opciones: Intl.DateTimeFormatOptions = {
                day: '2-digit',
                month: 'long',
                year: 'numeric'
              };
              let evaluacion = informe.toLocaleDateString('es-ES', opciones);
              setInformeEvaluacion(evaluacion);
            } else {
              console.error('Fecha inválida:', element.valormin);
            }
          } else {
            console.error('valormin es undefined o null');
          }
        }
      }
    };

    const sumatoriaTotal = juradosCriterios.reduce((total, j) => {
        return total + j.criterios.reduce((criterioTotal, c) => criterioTotal + c.nota, 0)/juradosCriterios.length;
    }, 0);

    const sumatoriaTotalRedondeado = parseFloat(sumatoriaTotal.toFixed(2));

    const getUser = async () => {
      try {
        const _user = getStorageUser()
        setUser(_user)
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      obtenerJuradosCriterios()
      getUser();
    }, [])

    // const [lineaConvocatoria, setLineaConvocatoria] = useState<any>({})
    // const obtenerLineaConvocatoria = async() => {
    //     try {
    //         // const { data } = await apiMaestras.obtenerLineaConvocatoria();
    //         // console.log(data)
    //         // const lineaConvocatoria = data.find((x: any) => x.id == datos.linea_convocatoria);

    //         // setLineaConvocatoria(lineaConvocatoria)
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    // useEffect(() => {
    //     obtenerLineaConvocatoria()

    // })

    return (
      <div>
        <Modal
            className="ant-modal-close-x2"
            maskStyle={{
                backgroundColor: "rgba(6, 100, 144 ,0.8)",
              }}
            title={
                <div className="w-100 font-family-Monserrat-SemiBold font-size-14px">
                Detalles de evaluación
            </div>
            }
            visible={openModal}
            onCancel={onCancel}
            width={1612}
            footer={
              <div className="row">
                <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                  {
                  user.role_id == 1 || user.documento == '8103442' || user.documento == '1234991493' ?
                    <Button className="button-azul-radius ms-1" onClick={() => porEvaluar()}
                    >
                      Por evaluar
                    </Button>
                  : <span></span>
                  }
                  {
                  user.role_id == 1 || user.documento == '8103442' || user.documento == '1234991493' ?
                    <Button className="button-azul-radius ms-1" onClick={() => evaluar(sumatoriaTotalRedondeado)}
                    >
                      Evaluar
                    </Button>
                  : <span></span>
                  }
                  <Button className="form_bg_btn button-blanco-radius" onClick={imprimir}>
                      Descargar
                  </Button>
                  <Button className="button-blanco-radius" onClick={onCancel}>
                      Cerrar
                  </Button>
                </div>
              </div>
            }
        >
           <div id="modal_custom" className="font-size-16px">
              <div className="container-fluid" style={{ marginTop: "10px", background: "white", padding: 30, borderRadius: "15px", }}>
                <Content className="category_mdl_box">
                  <Content className="cat_listing">
                    {[...juradosCriterios] // hacemos una copia para no mutar el array original
                      .sort((a: any, b: any) => a.primer_nombre.localeCompare(b.primer_nombre))
                      .map((j: any, idx: number) => {
                        const sumatoriaNotas = j.criterios.reduce((total: number, c: any) => total + c.nota, 0);
                        const sortedCriterios = j.criterios.sort((a, b) => a.id - b.id);
                        return (
                        <List
                          style={{ paddingTop: "5px", paddingBottom: "5px", }}
                          itemLayout="horizontal"
                          dataSource={sortedCriterios}
                          header={
                            <div>
                              <div className="container-fluid border bg-light p-4">
                                <div className="row">
                                  <Image src={EscudoAlcaldiaBlanco} style={{ maxWidth: "20%"}} preview={false} />
                                  <br />
                                  <br />
                                  <span className="md-title-text text-center font-size-16px">
                                    <br />
                                    SECRETARÍA DE CULTURA CIUDADANA
                                  </span>
                                  <br />
                                  <span className="md-title-text text-center font-size-16px">
                                    CONVOCATORIA DE FOMENTO Y ESTÍMULOS PARA EL ARTE Y LA CULTURA
                                  </span>
                                </div>
                                <br />
                                <br />
                                <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                  <div className="col-12 col-md-6 col-lg-3">
                                    <div className="row">
                                      <div className="col-md-12 font-family-Monserrat-SemiBold font-size-16px font-color-6C6868">
                                        Nombre
                                      </div>
                                      <div className="font-family-Work-Sans font-size-16px font-color-4B4B4B">
                                        {datos.nombre_propuesta}
                                        {console.log('datosssss', datos)}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 col-lg-3">
                                    <div className="row">
                                      <div className="col-md-12 font-family-Monserrat-SemiBold font-size-16px font-color-6C6868">
                                          Código
                                      </div>
                                      <div className="font-family-Work-Sans font-size-16px font-color-4B4B4B">
                                          {datos.radicado}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 col-lg-3">
                                    <div className="row">
                                      <div className="col-md-12 font-family-Monserrat-SemiBold font-size-16px font-color-6C6868">
                                        Línea
                                      </div>
                                      <div className="font-family-Work-Sans font-size-16px font-color-4B4B4B">
                                        {datos.linea_convocatoria}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 col-lg-3">
                                    <div className="row">
                                      <div className="col-md-12 font-family-Monserrat-SemiBold font-size-16px font-color-6C6868">
                                          Categoría
                                      </div>
                                      <div className="font-family-Work-Sans font-size-16px font-color-4B4B4B">
                                          {datos.categoria_linea_convocatoria}
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                              <List.Item style={{ background: '#ae3e97' }}>
                                <List.Item.Meta
                                  className="list_cat"
                                  title={
                                    <span className="cat_list_title font-family-Montserrat-Regular font-size-16px" style={{ padding:"10px", color:"white"}}>
                                      Jurado:
                                      <span style={{ fontWeight: 'bold' }}> {`${j.primer_nombre} ${j.segundo_nombre ? j.segundo_nombre : ''} ${j.primer_apellido} ${j.segundo_apellido ? j.segundo_apellido : ''}`}</span>
                                    </span>}
                                />
                                {
                                  user.role_id == 1 ?
                                    <Button
                                      onClick={() => {
                                          eliminarAsignacion(j.id_jurado, datos.id_postulacion);
                                        }
                                      }
                                      className="botones-acciones boton-borrar-adminconvocatorias"
                                      icon={<Icon name="trash alternate outline" />}
                                    />
                                  : <span></span>
                                    }
                              </List.Item>
                            </div>
                          }
                          footer={
                            <div>
                              <List.Item style={{ background: '#faad1424' }}>
                                <List.Item.Meta
                                  className="list_cat"
                                  title={<span className="cat_list_title font-family-Montserrat-Regular font-size-16px" style={{ padding:"10px"}}>Puntaje total:</span>}
                                  description={<span className="cat_list_title font-family-Montserrat-Regular font-size-16px" style={{ padding:"10px"}}>Puntaje total en letras: <span style={{ fontWeight: 'bold'}}>{obtenerLetras(sumatoriaNotas)}</span></span>}
                                />
                                <div className="font-size-16px" style={{ padding:"10px", fontWeight: 'bold', color: "black" }}>{sumatoriaNotas}</div>
                              </List.Item>
                              <div className="row">
                                {j.src && <Image src={j.src} style={{ maxWidth: "15%"}} />}
                              </div>
                              <div className="text-center font-size-16px">
                                {informeEvaluacion}
                              </div>
                              <div id="footer"></div>
                            </div>
                          }
                          renderItem={(item: any, index: number) => (
                            <List.Item key={index}  style={{ background: index % 2 === 0 ? '#f0f0f0' : 'white' }}>
                              <List.Item.Meta
                                className="list_cat"
                                title={<span className="cat_list_title font-family-Montserrat-Regular font-size-16px">{item.nombre}</span>}
                                description={<span className="cat_list_title font-family-Montserrat-Regular font-size-16px" style={{fontWeight: 'bold'}}>{item.observaciones}</span>}
                              />
                              <div className="font-size-16px" style={{ padding:"10px", fontWeight: 'bold' }}>{item.nota}</div>
                              {
                                user.role_id == 1 ?
                                  <Button
                                    onClick={() => {
                                        eliminarCriterio(item.id);
                                      }
                                    }
                                    className="botones-acciones boton-borrar-adminconvocatorias"
                                    icon={<Icon name="trash alternate outline" />}
                                  />
                                : <span></span>
                                  }
                            </List.Item>
                          )}
                        />
                      );
                    })}
                    <hr />
                    <div className="font-family-Montserrat-Bold font-size-16px" style={{ marginLeft: '80%' }}>
                      Puntaje promedio: {sumatoriaTotalRedondeado}
                    </div>
                  </Content>
                </Content>
              </div>
            </div>
        </Modal>
      </div>
    )
}
